import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import { beforeEachGuard } from '@/router/guard/index'
import { isManagerGuard } from './guard/permission'

import BaseLayout from '@/layouts/base.vue'
import EmptyLayout from '@/layouts/empty.vue'
import BeforeLoginLayout from '@/layouts/before_login.vue'
import AfterLoginLayout from '@/layouts/after_login.vue'
import GoalListLayout from '@/layouts/goal_list_layout.vue'
import EventsPageLayout from '@/layouts/events_page_layout.vue'
import MemberSelectLayout from '@/layouts/member_select_layout.vue'

import Login from '@/pages/auth/login.vue'

import PasswordReminder from '@/pages/auth/password_reminder.vue'
import PasswordSet from '@/pages/auth/password_set.vue'

import Members from '@/pages/members/index.vue'
import GoalList from '@/pages/members/goal_list.vue'
import GoalAdd from '@/pages/members/goal_add.vue'
import GoalEdit from '@/pages/members/goal_edit.vue'
import ActivityResultAdd from '@/pages/members/activity_result_add.vue'
import ActivityResultEdit from '@/pages/members/activity_result_edit.vue'
import MandalaEvaluation from '@/pages/members/mandala_evaluation/index.vue'

import Notifications from '@/pages/notifications.vue'
import Search from '@/pages/search.vue'
import Settings from '@/pages/settings.vue'
import SettingsPasswordUpdate from '@/pages/settings/password_update.vue'
import SettingsEmailUpdate from '@/pages/settings/email_update.vue'
import SettingsFollow from '@/pages/settings/follow.vue'

import Events from '@/pages/events/index.vue'
import EventAdd from '@/pages/events/add.vue'
import EventEdit from '@/pages/events/edit.vue'

import AdminMembers from '@/pages/admin/members.vue'
import AdminMemberAdd from '@/pages/admin/member_add.vue'
import AdminMemberEdit from '@/pages/admin/member_edit.vue'
import AdminGroups from '@/pages/admin/groups.vue'
import AdminGroupAdd from '@/pages/admin/group_add.vue'
import AdminGroupEdit from '@/pages/admin/group_edit.vue'
import AdminCategories from '@/pages/admin/categories.vue'
import AdminCategoryAdd from '@/pages/admin/category_add.vue'
import AdminCategoryEdit from '@/pages/admin/category_edit.vue'
import AdminTemplates from '@/pages/admin/templates.vue'
import AdminTemplateAdd from '@/pages/admin/template_add.vue'
import AdminTemplateEdit from '@/pages/admin/template_edit.vue'
import MandalaGoalTemplates from '@/pages/admin/mandala_goal_templates/index.vue'
import MandalaGoalTemplateAdd from '@/pages/admin/mandala_goal_templates/add.vue'
import MandalaGoalTemplateEdit from '@/pages/admin/mandala_goal_templates/edit.vue'
import MandalaEvaluationsExport from '@/pages/admin/mandala_evaluations_export/index.vue'
import MandalaEvaluationsExportPreview from '@/pages/admin/mandala_evaluations_export/preview.vue'

import Maintenance from '@/pages/maintenance.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: BaseLayout,
    children: [
      {
        path: '',
        meta: { isLoginRequired: true },
      },
      {
        path: 'maintenance',
        component: Maintenance,
      },
      {
        path: 'auth/',
        component: BeforeLoginLayout,
        children: [
          {
            path: 'login',
            component: Login,
            beforeEnter: async (to, from, next) => {
              const isExpired = await store.dispatch('auth/tokenIsExpired')
              if (isExpired) {
                await store.dispatch('auth/logout')
              }
              next()
            }
          },
          {
            path: 'password_reminder',
            component: PasswordReminder
          },
          {
            path: 'password_set',
            component: PasswordSet,
          }
        ],
      },
      {
        path: 'members/',
        component: AfterLoginLayout,
        meta: { isLoginRequired: true },
        children: [
          {
            path: '',
            component: Members,
          },
          {
            path: ':id/',
            component: MemberSelectLayout,
            children: [
              {
                path: '',
                component: GoalListLayout,
                children: [
                  {
                    path: '',
                    name: 'goalList',
                    component: GoalList
                  },
                ]
              },
              {
                name: 'mandalaEvaluation',
                path: 'mandala_evaluation',
                component: MandalaEvaluation,
              },
              {
                path: 'goal_add',
                component: GoalAdd,
              },
              {
                path: 'goal_edit/:goalId',
                component: GoalEdit,
              },
              {
                path: 'goal/:goalId/activity_result_add',
                component: ActivityResultAdd,
              },
              {
                path: 'goal/:goalId/activity_result_edit/:activityId',
                component: ActivityResultEdit,
              },
            ]
          },
        ]
      },
      {
        path: 'events/',
        component: AfterLoginLayout,
        meta: {isLoginRequired: true},
        children: [
          {
            path: '',
            component: EventsPageLayout,
            children: [
              {
                path: '',
                name: 'events',
                component: Events
              }
            ]
          },
          {
            path: 'add',
            name: 'eventAdd',
            component: EventAdd,
            beforeEnter: isManagerGuard('/events'),
          },
          {
            path: ':id/edit',
            name: 'eventEdit',
            component: EventEdit,
            beforeEnter: isManagerGuard('/events'),
          },
        ]
      },
      {
        path: '/notifications/',
        component: AfterLoginLayout,
        meta: { isLoginRequired: true },
        children: [
          {
            path: '',
            component: Notifications,
          },
        ]
      },
      {
        path: '/search/',
        component: AfterLoginLayout,
        meta: { isLoginRequired: true },

        children: [
          {
            path: '',
            component: Search,
          },
        ]
      },
      {
        path: '/settings/',
        component: AfterLoginLayout,
        meta: { isLoginRequired: true },
        children: [
          {
            name: 'settings',
            path: '',
            component: Settings,
          },
          {
            name: 'passwordUpdate',
            path: 'password_update',
            component: SettingsPasswordUpdate,
          },
          {
            name: 'emailUpdate',
            path: 'email_update',
            component: SettingsEmailUpdate,
          },
          {
            name: 'follow',
            path: 'follow',
            component: SettingsFollow,
          },
        ]
      },
      {
        path: '/admin/',
        component: AfterLoginLayout,
        children: [
          {
            path: 'members/',
            component: EmptyLayout,
            children: [
              {
                path: '',
                component: AdminMembers,
              },
              {
                path: 'add',
                component: AdminMemberAdd,
              },
              {
                path: ':id/edit',
                component: AdminMemberEdit,
              },
            ]
          },
          {
            path: 'groups/',
            component: EmptyLayout,
            children: [
              {
                path: '',
                component: AdminGroups,
              },
              {
                path: 'add',
                component: AdminGroupAdd,
              },
              {
                path: ':groupId/edit',
                component: AdminGroupEdit,
              },
            ]
          },
          {
            path: 'categories/',
            component: EmptyLayout,
            children: [
              {
                path: '',
                component: AdminCategories,
              },
              {
                path: 'add',
                component: AdminCategoryAdd,
              },
              {
                path: ':categoryId/edit',
                component: AdminCategoryEdit,
              },
            ]
          },
          {
            path: 'templates/',
            component: EmptyLayout,
            children: [
              {
                path: '',
                component: AdminTemplates,
              },
              {
                path: 'add',
                component: AdminTemplateAdd,
              },
              {
                path: ':templateId/edit',
                component: AdminTemplateEdit,
              },
            ]
          },
          {
            path: 'mandala_goal_templates/',
            component: EmptyLayout,
            children: [
              {
                path: '',
                component: MandalaGoalTemplates,
              },
              {
                path: 'add',
                component: MandalaGoalTemplateAdd,
              },
              {
                path: ':id',
                component: MandalaGoalTemplateEdit,
              },
            ]
          },
          {
            path: 'mandala_evaluations_export/',
            component: EmptyLayout,
            children: [
              {
                path: '',
                name: 'mandalaEvaluationsExport',
                component: MandalaEvaluationsExport,
              },
            ]
          }
        ]
      },
      // このページは印刷用ページなのでレイアウトが不要
      {
        path: 'admin/mandala_evaluations_export/preview',
        name: 'mandalaEvaluationsExportPreview',
        component: MandalaEvaluationsExportPreview,
        beforeEnter: isManagerGuard('/'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(beforeEachGuard)

router.afterEach(() => {
  // 画面遷移時は画面上部に強制スクロール
  window.scrollTo(0, 0)
})

export default router
